import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Mail } from "lucide-react";
import config from "../config/environment.js";
import { getEnvsVariable } from "../utils/getEnvsVariable.js";

const env = getEnvsVariable();
import bgImage from "../assets/images/login-bg.png";
import logoNSSA from "../assets/images/logo_nssa.png";
import logoSUBEBlanco from "../assets/images/logo_sube_blanco.svg";

const styles = {
  page: {
    minHeight: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "48px 16px",
    position: "relative",
    backgroundImage: `url(${bgImage})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
  },
  overlay: {
    position: "absolute",
    inset: 0,
    // backgroundColor: "rgba(0, 71, 124, 0.60)",
  },
  glassCard: {
    position: "relative",
    zIndex: 10,
    width: "100%",
    maxWidth: "560px",
    borderRadius: "16px",
    padding: "32px 56px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "24px",
    background: "rgba(255,255,255,0.08)",
    backdropFilter: "blur(15px)",
    WebkitBackdropFilter: "blur(20px)",
    border: "1px solid rgba(255,255,255,0.20)",
    boxShadow: "0 8px 48px rgba(0,0,0,0.40)",
  },
  whiteCard: {
    width: "100%",
    backgroundColor: "#fff",
    borderRadius: "12px",
    padding: "24px 28px",
    boxShadow: "0 4px 24px rgba(0,0,0,0.10)",
  },
  form: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
  },
  label: {
    display: "block",
    fontSize: "0.875rem",
    fontWeight: 500,
    color: "#4B5563",
    marginBottom: "4px",
  },
  inputWrapper: {
    position: "relative",
  },
  iconLeft: {
    position: "absolute",
    left: "12px",
    top: "50%",
    transform: "translateY(-50%)",
    color: "#9CA3AF",
    pointerEvents: "none",
  },
  input: {
    width: "100%",
    paddingLeft: "36px",
    paddingRight: "16px",
    paddingTop: "10px",
    paddingBottom: "10px",
    borderRadius: "8px",
    border: "1px solid #E5E7EB",
    backgroundColor: "#F9FAFB",
    fontSize: "0.875rem",
    color: "#1F2937",
    outline: "none",
    boxSizing: "border-box",
  },
  submitBtn: {
    width: "100%",
    padding: "10px",
    borderRadius: "8px",
    border: "none",
    backgroundColor: "#00603D",
    color: "#fff",
    fontWeight: 600,
    fontSize: "0.875rem",
    letterSpacing: "0.05em",
    cursor: "pointer",
    boxShadow: "0 1px 4px rgba(0,0,0,0.15)",
  },
  submitBtnDisabled: {
    backgroundColor: "#6B7280",
    cursor: "not-allowed",
  },
  errorBox: {
    fontSize: "0.8rem",
    color: "#B91C1C",
    backgroundColor: "#FEF2F2",
    border: "1px solid #FECACA",
    borderRadius: "6px",
    padding: "8px 12px",
    textAlign: "center",
  },
  successBox: {
    fontSize: "0.875rem",
    color: "#065F46",
    backgroundColor: "#ECFDF5",
    border: "1px solid #6EE7B7",
    borderRadius: "6px",
    padding: "12px 16px",
    textAlign: "center",
    lineHeight: 1.5,
  },
  backBtn: {
    background: "none",
    border: "none",
    padding: 0,
    fontSize: "0.75rem",
    color: "#3080C2",
    cursor: "pointer",
    textDecoration: "none",
    display: "block",
    textAlign: "center",
    marginTop: "4px",
  },
};

export default function ForgotPassword() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      // await fetch(
      //   `${env.VITE_API_USER_API_EMAIL}/${encodeURIComponent(email)}`,
      //   { method: "POST" }
      // );
      await fetch(
        `${env.VITE_API_USER_UTILS_SUPERVISOR}/resetPassword/${encodeURIComponent(email.toLowerCase())}`,
        { method: "POST" }
      );
    } catch {
      setLoading(false);
      setError("No pudimos enviar el correo. Verificá tu conexión e intentá de nuevo.");
      return;
    } finally {
      setLoading(false);
    }
    setSuccess(true);
  };

  return (
    <div style={styles.page}>
      <div style={styles.overlay} />

      <div style={styles.glassCard}>
        <img src={logoNSSA} alt="Nación Servicios" style={{ height: "calc(var(--spacing) * 10)", width: "auto" }} />

        <div style={styles.whiteCard}>
          {success ? (
            <div style={styles.form}>
              <div style={styles.successBox}>
                Revisá tu casilla, te enviamos un correo de recuperación.
              </div>
              <button type="button" onClick={() => navigate("/login")} style={styles.backBtn}>
                Volver al login
              </button>
            </div>
          ) : (
            <form onSubmit={handleSubmit} style={styles.form}>
              <div>
                <label htmlFor="forgot-email" style={styles.label}>
                  Email
                </label>
                <div style={styles.inputWrapper}>
                  <span style={styles.iconLeft}>
                    <Mail size={16} aria-hidden="true" />
                  </span>
                  <input
                    id="forgot-email"
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="Ingrese su email"
                    style={styles.input}
                    autoComplete="email"
                    required
                  />
                </div>
              </div>

              {error && <div style={styles.errorBox}>{error}</div>}

              <button
                type="submit"
                disabled={loading}
                style={loading ? { ...styles.submitBtn, ...styles.submitBtnDisabled } : styles.submitBtn}
              >
                {loading ? "Enviando..." : "Enviar"}
              </button>

              <button type="button" onClick={() => navigate("/login")} style={styles.backBtn}>
                Volver al login
              </button>
            </form>
          )}
        </div>

        <img src={logoSUBEBlanco} alt="SUBE" style={{ height: "40px", width: "auto" }} />
      </div>
    </div>
  );
}
